import { render, staticRenderFns } from "./SuperAdminAuthPageLayout.vue?vue&type=template&id=5bb69757&scoped=true&"
import script from "./SuperAdminAuthPageLayout.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAuthPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminAuthPageLayout.vue?vue&type=style&index=0&id=5bb69757&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb69757",
  null
  
)

export default component.exports